import { render, staticRenderFns } from "./SubscribePopUp.vue?vue&type=template&id=80d4ce48&lang=pug&"
import script from "./SubscribePopUp.vue?vue&type=script&lang=js&"
export * from "./SubscribePopUp.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports